module.exports = __webpack_public_path__ + "static/media/current-step-icon.aa5d83d3.svg";